import * as React from "react";
const SvgPlastic = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", id: "Capa_1", x: "0px", y: "0px", viewBox: "0 0 512.153 512.153", style: {
  enableBackground: "new 0 0 512.153 512.153"
}, xmlSpace: "preserve", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
}, d: "M484.994,129.888H307.356V75.671\n			c0-2.427,1.967-4.394,4.394-4.394h168.851c2.427,0,4.394,1.967,4.394,4.394V129.888z" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
}, d: "M307.356,129.888l-18.721,51.651\n			c-0.441,1.216-0.666,2.499-0.666,3.793v308.192c0,6.147,4.983,11.13,11.13,11.13h194.152c6.147,0,11.13-4.983,11.13-11.13V185.331\n			c0-1.293-0.225-2.577-0.666-3.793l-18.721-51.651" })), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M327.561,69.062l-4.544-52.113c-0.466-5.346-4.942-9.449-10.309-9.449h-39.237c-5.715,0-10.348,4.633-10.348,10.348v97.161\n			c0,3.533-2.864,6.397-6.397,6.397h-95.123" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M126.832,121.406h-25.713c-3.533,0-6.397-2.864-6.397-6.397V17.848c0-5.715-4.633-10.348-10.348-10.348H45.138\n			c-5.367,0-9.842,4.103-10.309,9.449L8.531,318.535c-1.601,18.354-0.667,36.842,2.774,54.942l23.338,122.761\n			c0.928,4.882,5.196,8.415,10.166,8.415h254.29" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M484.994,129.888H307.356V75.671c0-2.427,1.967-4.394,4.394-4.394h168.851c2.427,0,4.394,1.967,4.394,4.394V129.888z" }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 299.099, y1: 504.653, x2: 409.773, y2: 504.653 }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M444.696,504.653h48.555c6.147,0,11.13-4.983,11.13-11.13V185.331c0-1.293-0.225-2.577-0.666-3.793l-18.721-51.651H307.356\n			l-18.721,51.651c-0.441,1.216-0.666,2.499-0.666,3.793v63.071" }), /* @__PURE__ */ React.createElement("polyline", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, points: "\n			287.969,248.402 287.969,223.145 504.381,223.145 504.381,464.885 306.609,464.885 		" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M326.208,311.26H164.614c-3.152,0-5.706-2.555-5.706-5.706v-19.155c0-3.152,2.555-5.706,5.706-5.706h161.593\n			c3.152,0,5.706,2.555,5.706,5.706v19.155C331.914,308.706,329.36,311.26,326.208,311.26z" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M172.813,311.26l13.678,184.287c0.367,4.943,4.484,8.765,9.44,8.765h98.96c4.956,0,9.073-3.823,9.44-8.765l13.678-184.287H172.813\n			z" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M301.558,251.08H189.264c-3.451,0-6.417,2.447-7.073,5.835l-4.602,23.777h135.644l-4.602-23.777\n			C307.975,253.528,305.009,251.08,301.558,251.08z" }))));
export default SvgPlastic;
